import { render, staticRenderFns } from "./ModelAssessmentReport.vue?vue&type=template&id=154588d8&scoped=true&"
import script from "./ModelAssessmentReport.vue?vue&type=script&lang=js&"
export * from "./ModelAssessmentReport.vue?vue&type=script&lang=js&"
import style0 from "./ModelAssessmentReport.vue?vue&type=style&index=0&id=154588d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154588d8",
  null
  
)

export default component.exports